import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import cns from '../../node_modules/classnames/index.js';
import Tooltip from '../Tooltip/Tooltip.js';

/**
Testo che mostra i "tre puntini" se supera lo spazio assegnato e il testo completo nella tooltip.
*/
function EllipsisText({ className = undefined, children = null, left = false, top = true, disabled = false, numberOfLines = 1, }) {
    const ref = useRef();
    const textClassname = cns('ellipsis__text', className, { 'ellipsis__text--multilines': numberOfLines > 1 });
    const textStyle = numberOfLines > 1 ? { WebkitLineClamp: numberOfLines } : undefined;
    return (jsx(Tooltip, { content: children, left: left, top: top, right: !left, enableFunction: () => !disabled && ref.current && ((ref.current.offsetWidth < ref.current.scrollWidth)
            || (ref.current.offsetHeight < ref.current.scrollHeight)), className: "ellipsis__info-tooltip", children: jsx("span", { className: textClassname, ref: ref, style: textStyle, children: children }) }));
}

export { EllipsisText as default };
